import { Grid } from '@mui/material';
import { useMap } from 'es-map-widget';
import React, { useState } from 'react';
import { CONTROLLER_KEYS, CONTROLLER_LABELS } from '../../../constants';
import { MAP_LAYER_NAMES } from '../../../constants/mapLayerNames';
import { useLayout } from '../../../providers/LayoutContext';
import { useMenu } from '../contexts/MenuContext';
import MapControllerMenuItem from '../menu/MapControllerMenuItem';

const CitiesController = () => {
    const map = useMap();
    const { checkedItems, handleItemCheck } = useMenu();
    const { matchesLgUp } = useLayout();
    const [isLayerVisible, setIsLayerVisible] = useState(
        checkedItems[CONTROLLER_KEYS.CITIES].includes(CONTROLLER_KEYS.CITIES)
    );

    return (
        <Grid container>
            <Grid item xs={12} lg={6} className={!matchesLgUp ? 'mobile' : ''}>
                <MapControllerMenuItem
                    text={CONTROLLER_LABELS.CITIES_BORDER}
                    checkbox={{
                        checked: isLayerVisible,
                        onChange: (event) => {
                            setIsLayerVisible((p) => !p);
                            if (!event.target.checked) {
                                map.setLayerData(MAP_LAYER_NAMES.CITY, {
                                    isLayerVisible: false,
                                });
                                map.setLayerVisibility(MAP_LAYER_NAMES.CITY, false);
                            } else {
                                map.setLayerData(MAP_LAYER_NAMES.CITY, {
                                    isLayerVisible: true,
                                });
                                map.setLayerVisibility(MAP_LAYER_NAMES.CITY, true);
                            }
                            handleItemCheck(CONTROLLER_KEYS.CITIES, CONTROLLER_KEYS.CITIES);
                        },
                    }}
                    hasSubMenu={false}
                />
            </Grid>
        </Grid>
    );
};

export default CitiesController;
